import Notifications from './Notifications';

const HistoryNotifications = ({ route }: any) => {

  return (
    <>
      <Notifications isOpen={'notification'} />
    </>
  );
};

export default HistoryNotifications;
